import * as React from 'react';
const DownloadIcon = (props) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    className="ml-1 mt-1"
    fill='#0000FF'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z'
      fill='#0000FF'
    />
  </svg>
);
export default DownloadIcon;
